// Central S.DRIVE contact info — keep in one place so it stays consistent everywhere.
export const SDRIVE_CONTACT = {
  phone: "+33 6 31 81 34 58",
  phoneRaw: "+33631813458",
  email: "contact@sdrive-transfert.fr",
};

// ── WhatsApp helpers ────────────────────────────────────────────────
// wa.me expects digits only (country code included, no + no spaces).
// If the number starts with "0" and is 10 digits long, we assume a French
// mobile and prepend 33. Otherwise we just keep the digits (already has
// a country code).
export function toWhatsAppNumber(phone) {
  if (!phone) return "";
  let digits = String(phone).replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length === 10 && digits.startsWith("0")) {
    digits = "33" + digits.slice(1);
  }
  // Leading zeros from other countries should already be normalized by user.
  return digits;
}

export function buildRideWhatsAppText(ride, { includeHeader = true } = {}) {
  if (!ride) return "";
  const L = [];
  if (includeHeader) L.push("Nouvelle course");
  L.push(`Date : ${ride.pickup_date || "-"} à ${ride.pickup_time || "-"}`);
  if (ride.route_label) L.push(`Trajet : ${ride.route_label}`);
  if (ride.ride_type) L.push(`Véhicule : ${String(ride.ride_type).toUpperCase()}`);
  if (ride.passenger_count) L.push(`Passagers : ${ride.passenger_count}`);
  if (ride.luggage_count) L.push(`Bagages : ${ride.luggage_count}`);
  if (ride.driver_fare != null) L.push(`Prix TTC : ${ride.driver_fare} EUR`);
  L.push("— Sdrive Transfert");
  return L.join("\n");
}

export function buildDriverReminderText(ride, driverName = "") {
  const who = driverName ? `Bonjour ${driverName}, ` : "Bonjour, ";
  return (
    `${who}petite relance pour la course ${ride?.route_label || ""} ` +
    `prévue le ${ride?.pickup_date || ""} à ${ride?.pickup_time || ""}. ` +
    `Merci de confirmer votre disponibilité. — Sdrive Transfert`
  );
}

// Personal driver ride → WhatsApp share text (Phase 1). No header from
// S.DRIVE — the driver is sharing one of their own jobs informally.
export function buildPersonalRideShareText(ride) {
  if (!ride) return "";
  const L = [];
  if (ride.client_name) L.push(`Client : ${ride.client_name}`);
  if (ride.pickup_location) L.push(`Départ : ${ride.pickup_location}`);
  if (ride.dropoff_location) L.push(`Arrivée : ${ride.dropoff_location}`);
  if (ride.pickup_date || ride.pickup_time) {
    L.push(`Date : ${ride.pickup_date || "-"} à ${ride.pickup_time || "-"}`);
  }
  if (ride.price != null && ride.price !== "") L.push(`Prix : ${ride.price} EUR`);
  return L.join("\n");
}

// Open a WhatsApp conversation in a new tab.
// - If `phone` is empty, the user lands on wa.me with only the text so they
//   can paste it into any chat/group they choose.
export function openWhatsApp(phone, text) {
  const num = toWhatsAppNumber(phone);
  const encoded = encodeURIComponent(text || "");
  const url = num ? `https://wa.me/${num}?text=${encoded}` : `https://wa.me/?text=${encoded}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

// Copy text to clipboard with a best-effort fallback.
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text || "");
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text || "";
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus(); ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      return true;
    } catch {
      return false;
    }
  }
}
